const liveChatFunction = {
    show_date : tp => {
        let date = new Date(tp * 1000);
        let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
        let getMonth = date.getMonth() + 1;
        let month = getMonth > 9 ? getMonth : '0' + getMonth;
        let hour = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
        let minu = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
        let seco = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
        let dateFormated = 
            day + '/' + month + '/' + date.getFullYear() + ' - ' + 
            hour + ':' + minu + ':' + seco;
            
        return dateFormated;
    },
    sendNewMessage : (
            mess = '',
            state,
            dispatch,
            setNewMessage,
            setMessageLength,
            getActiveCom,
        ) => {
            let message = document.querySelector('#newMessageContent').value;
            if (message !== '' || mess !== '') {
                // console.log('test : ', state.active_communication)
                // let userId = state.active_communication[1].user_id;
                let userId = state.active_communication[0].user_id;
                let chatId =
                state.active_communication.length > 0
                    ? state.active_communication[0].chat_id
                    // ? state.active_communication[1].chat_id
                    : 0;
                let chatIssue =
                    state.com_list.length > 0
                    ? state.com_list[0].chat_issue :
                    '';
                let chatContinuation = 
                    state.com_list.length > 0
                        ? state.com_list[0].chat_continuation_nb
                        : '0';
                setNewMessage(
                    state.current_operator_id,
                    chatId,
                    userId,
                    chatIssue,
                    chatContinuation,
                    message !== '' ? message : mess,
                    dispatch,
                    state,
                );
                setMessageLength(0);
                document.querySelector('#newMessageContent').value = '';
                setTimeout(() => getActiveCom(state, chatId, dispatch), 500);
            }
      },
};

export default liveChatFunction;